import { MemberRepresentationDto } from "@api/user-app-service";
import { AdminListItem } from "../interfaces/admin-list-item.interface";
import { Role } from "../interfaces/role.interface";

export function preserveAdminListEnrichment(
  admin: MemberRepresentationDto,
  existingAdmin?: AdminListItem,
  updatedRoles?: Role[],
): AdminListItem {
  const listRoles =
    updatedRoles?.map(role => role.name).filter((name): name is string => !!name) ?? admin.listRoles ?? existingAdmin?.listRoles;

  return {
    ...admin,
    listRoles,
    listOrganizations: admin.listOrganizations ?? existingAdmin?.listOrganizations,
  };
}
